export default {"src":"/_next/static/media/icon-telegram.486bf2ba.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};